import { SearchModes } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { ConfigValuesApp } from '@/app/common/config/configuration/configurationTypes.ts';
import { getIsFlex } from '@/app/components/search/Utilities.ts';

type FilterFlags = Partial<
  Pick<
    ConfigValuesApp,
    | 'useNewFilters'
    | 'evolutionResultsOnlyEnabled'
    | 'useEvoFilters'
    | 'useNewFacilities'
    | 'hideFreeCancellationOnResults'
    | 'depositAmountEnabled'
  >
>;

// configValuesApp owns the whole rule: the Evo shell and the destinations page always get them, and the
// TSX results page never does. These only read the result.
export const newFiltersEnabled = (config?: FilterFlags): boolean => Boolean(config?.useNewFilters);

export const evoFiltersEnabled = (config?: FilterFlags): boolean =>
  newFiltersEnabled(config) && Boolean(config?.useEvoFilters);

export const newFacilitiesEnabled = (config?: FilterFlags): boolean =>
  newFiltersEnabled(config) && Boolean(config?.useNewFacilities);

// MPH-1034: cux_4082 variant T. One source for the descriptor and the builder.
export const freeCancellationWithdrawn = (config?: FilterFlags): boolean =>
  Boolean(config?.hideFreeCancellationOnResults);

// One source for the TSX sidebar, the new filters and the availability descriptor: the deposit is an
// HO offer, and a flexible search has no fixed dates to hold it.
export const bookNowPayLaterAvailable = ({
  config,
  searchMode,
  searchParams,
}: {
  config?: FilterFlags;
  searchMode?: SearchModes;
  searchParams: SearchParams;
}): boolean => Boolean(config?.depositAmountEnabled) && searchMode === SearchModes.HO && !getIsFlex(searchParams);
